import { Button, Logo } from "../../atoms"
import { useContext, useEffect, useMemo, useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import './Navbar.css'
import useMediaQuery from "../../../hook/useMediaQuery"
import { ToggleMenu } from "../../atoms/ToggleMenu/ToggleMenu"
import { AppGeneralContext } from "../../../shared/GeneralContext/GeneralContext"
import { AnchorMenu } from "../../atoms/AnchorMenu"
import { MediaDesktop, MediaMobile, MediaTablet } from "../../../api/const/MediaQuery"
import clsx from "clsx"
import logo from "./../../../assets/logoIM.png"
import { LoginType } from "components/types/Context"
import { useAuth } from "shared/auth"


export const Navbar = () => {
  const navigate = useNavigate();
  const mobile = useMediaQuery(MediaMobile);
  const tablet = useMediaQuery(MediaTablet);
  const desktop = useMediaQuery(MediaDesktop);
  const { menuIsOpen, setMenuIsOpen, user, loginType } = useContext(AppGeneralContext)
  const location = useLocation()
  const [home, setHome] = useState<string>("")
  const {auth}= useAuth()

  useEffect(() => {
    if (user?.email) {
      let route = loginType === LoginType.startup ? "start-up" : "corporate"
      setHome(`${route}/profile`)
    } else {
      if(location.pathname.includes("/login")){
        setHome("https://www.innovationmatch.io/")
        return 
      }
      setHome("/login")
    }
  }, [user?.email, loginType, location.pathname])




  const showNavigationMenu = useMemo(() => {
// Location condition Start
    if (location.pathname === '/' ||
      location.pathname.toLowerCase().includes('/login') ||
      location.pathname.toLowerCase().includes('/getstarted')) {


      if (mobile || tablet) {
        return <div className="col-sm-2 me-2 d-flex justify-content-end align-items-center ">
          <div className="d-flex justify-content-end">
            <ToggleMenu
              isOpen={menuIsOpen}
              className=''
              onClick={() => { setMenuIsOpen(!menuIsOpen) }}
            />
          </div>
        </div>
      }

      if (desktop) {
        return (
          <div className="col-lg-6 d-flex justify-content-end align-items-center pe-3">
            <div className="d-flex justify-content-end">
              <ToggleMenu
                isOpen={menuIsOpen}
                className='me-4'
                onClick={() => { setMenuIsOpen(!menuIsOpen) }}
              />
              <Button className=''
                color='var(--white)'
                background='var(--primary)'
                borderColor='var(--primary)'
                fontWeight={'800'}
                uppercase
                primary
                text='Register now'
                onClick={() => {
                  const registerPath = loginType === LoginType.startup ? '/startup' : ''
                  navigate(`/getStarted${registerPath}`)
                  }} />
            </div>
          </div>
        )
      }
      return (
        <div className="col-9  d-flex justify-content-end align-items-center m-0 pe-3 ">
          <AnchorMenu />
           
          <div className="d-flex justify-content-end align-items-center m-0 p-0">
           
            <Button className=''
              color='var(--white)'
              background='var(--primary)'
              borderColor='var(--primary)'
              fontWeight={'800'}
              uppercase
              primary
              text='Register now'
              onClick={() => {
                const registerPath = loginType === LoginType.startup ? '/startup' : ''
                navigate(`/getStarted${registerPath}`)
                }} />
          </div>
        </div>)

    } 
// Location condition Else    
    else {

      if(!auth?.jwtToken){
        return <div className="pb-4 pt-4"></div>
      }

      if (tablet || mobile) {
        return <div className="pb-4 pt-4"></div>
      }


      if (desktop) {
        return (
          <>
            <div className=" d-flex justify-content-end align-items-center ">
              <div className="d-flex justify-content-end">
                <ToggleMenu
                  isOpen={menuIsOpen}
                  className='me-4'
                  onClick={() => { setMenuIsOpen(!menuIsOpen) }}
                />
              </div>
            </div>
          </>
        )
      }

      return (
        <>
          <div className=" w-100 align-items-center ">
            <div className="d-flex justify-content-end">
              <ToggleMenu
                isOpen={menuIsOpen}
                className='me-4'
                onClick={() => { setMenuIsOpen(!menuIsOpen) }}
              />
            </div>
          </div>
          <div className="col-lg2 " />
        </>
      )
    }

  }, [mobile, tablet, desktop, menuIsOpen, location.pathname, menuIsOpen, navigate, auth?.jwtToken, loginType])



  return (
    <nav className={clsx("w-100 d-flex align-items-center justify-content-between pe-5 ")}>
      <Link to={home}
        className={clsx(" w-100 d-flex row justify-content-start align-items-center text-decoration-none",
        )}>
        <img className="h-logo" style={{width:"450px !important"}} src={logo} alt={"innovation Match logo"} />
      </Link>
      {showNavigationMenu}
    </nav>
  )
}